import React from 'react';
import styled from 'styled-components';
import { ProjectFilesAPI } from 'api/project-files';
import { useUser } from 'hooks/use-user';
import { logger } from 'services';

interface DownloadLinkProps {
  url: string;
}

const StyledLink = styled.a`
  color: inherit;
`;

export const DownloadLink: React.FC<DownloadLinkProps> = ({
  url,
  children,
}) => {
  const { user } = useUser();

  const onDownloadClick: React.MouseEventHandler<HTMLAnchorElement> = async (
    e,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const token = await ProjectFilesAPI.getDownloadToken(user.emailId);

      const ele = document.createElement('a');

      ele.href = `${url}?token=${token}`;

      document.body.appendChild(ele);
      ele.click();
      ele.remove();
    } catch (error) {
      logger.error('Download failed', { error });
    }
  };

  return <StyledLink onClick={onDownloadClick}> {children} </StyledLink>;
};

export const DownloadFromApi: React.FC<{
  api: () => Promise<{ url: string }>;
  children?: React.ReactElement;
}> = ({ api, children }) => {
  const onDownloadClick: React.MouseEventHandler<HTMLAnchorElement> = async (
    e,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const { url } = await api();

      const ele = document.createElement('a');

      ele.href = url;

      document.body.appendChild(ele);
      ele.click();
      ele.remove();
    } catch (error) {
      logger.error('Download failed', { error });
    }
  };

  return <StyledLink onClick={onDownloadClick}> {children} </StyledLink>;
};
